import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import RoutesserviceService from '../routesservice.service';
import { HeaderService } from '../header.service';

const httpOptions= new HttpHeaders()
  .set('content-type', 'application/json');

@Injectable({
  providedIn: 'root'
})
export class MediaService {
  constructor( private Customeroutes: RoutesserviceService , private http: HttpClient,
     private httpClient: HttpClient,
    private HeaderService: HeaderService

  ) {

   }

  addMedia(formData: any){
    const token = localStorage.getItem('token');
    const url = `${environment.apiBaseUrl}/add-media`;
    const httpFormDataOptions= new HttpHeaders();
    return  this.http.post<any>(url, formData, {headers: httpFormDataOptions.append('Authorization', `Bearer ${token}`)});
  }
  uploadImage(formData: any){
    const token = localStorage.getItem('token');
    const url = this.Customeroutes.uploadImage();
    const httpFormDataOptions= new HttpHeaders();
    return  this.http.post<any>(url, formData, {headers: httpFormDataOptions.append('Authorization', `Bearer ${token}`)});
  }

  showMedia(){
    const token = localStorage.getItem('token');

    const url = `${environment.apiBaseUrl}/show-media`;
    return  this.http.post<any>(url, null, { headers: httpOptions.append('Authorization', `Bearer ${token}`) });
  }


async deleteMedia(imageid:any) {
      const olduser = { id: imageid}
    return this.httpClient
      .post(this.Customeroutes.deleteMedia(), olduser, {
        headers: this.HeaderService.getHeaderWithToken(
          localStorage.getItem('token')
        ),
      })
      .pipe()
      .toPromise()
      .then((data: any) => {
        if (data.success == true) {

          return data;

        }
        return data;
      });
    }




}


